interface CloudiaService {
  port: number;
  basePath: string;
  endpoints?: string[];
}
export class CloudiaServices {
  BUSINESS_MANAGEMENT: CloudiaService = {
    port: 8086,
    basePath: 'businessService',
  };
  SEARCH_ENGINE: CloudiaService = {
    port: 8093,
    basePath: 'searchEngine',
  };
  DOCUMENT_MANAGEMENT: CloudiaService = {
    port: 8090,
    basePath: 'documentService',
  };
  EMPLOYEE_MANAGEMENT: CloudiaService = {
    port: 8084,
    basePath: 'employeeService',
  };
  GRADE_MATRIX_MANAGEMENT: CloudiaService = {
    port: 8092,
    basePath: 'gradeService',
  };
  USER_MANAGEMENT: CloudiaService = {
    port: 8080,
    basePath: 'usersService',
  };
  NOTIFICATION_MANAGEMENT: CloudiaService = {
    port: 8080,
    basePath: 'notificationService',
  };
  ORCHESTRATOR_MANAGEMENT: CloudiaService = {
    port: 8083,
    basePath: 'orchestratorService',
  };
  CSAT_MANAGEMENT: CloudiaService = {
    port: 8088,
    basePath: 'csatService',
  };
  GM_ENGINE: CloudiaService = {
    port: 8094,
    basePath: 'gmService',
  };
  RANKING: CloudiaService = {
    port: 8100,
    basePath: 'cvRankingService',
  };
  ITBM: CloudiaService = {
    port: 8087,
    basePath: 'itbmService',
  };

  get(key: keyof CloudiaServices) {
    return this[key] as CloudiaService;
  }
}
